import React, { useEffect, useRef, useState } from "react";
import {
  BodySlideImage,
  BodySliderWrapper,
  BodySlider,
  BodySlide,
  Paragraph,
  ParagraphContainer,
} from "../styles/components/body";
import animations from "../animations/animations";
import { BREAKPOINTS } from "../styles/variables/breakpoints";

const BodySliderComponent = ({ articleData, bodyItems }) => {
  const [hasMounted, setHasMounted] = useState(false);
  const wrapperRef = useRef(null);
  const bodySliderRef = useRef(null);
  const firstSlideRef = useRef(null);
  const firstImageMobileRef = useRef(null);
  const paragraphRef = useRef(null);

  const images = bodyItems?.[0]?.images || [];

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    if (
      !wrapperRef.current ||
      !firstSlideRef.current ||
      !firstImageMobileRef.current ||
      !bodySliderRef.current ||
      typeof window === "undefined" ||
      !hasMounted
    ) {
      return;
    }

    const mm = animations.matchMedia();

    mm.add(`(max-width: ${BREAKPOINTS.sm - 1}px)`, () => {
      animations
        .timeline({
          scrollTrigger: {
            trigger: firstSlideRef.current,
            start: "center top",
            end: "bottom top",
            scrub: true,
          },
        })
        .to(firstImageMobileRef.current, {
          filter: "blur(10px)",
        });
    });

    setTimeout(() => {
      if (paragraphRef.current) {
        animations.parallax(paragraphRef.current, 20, true);
      }
    }, 1000);

    return () => mm.revert();
  }, [hasMounted]);

  return (
    <>
      <BodySliderWrapper ref={wrapperRef} suppressHydrationWarning>
        <BodySlider ref={bodySliderRef}>
          {images?.[0] && (
            <BodySlide
              ref={firstSlideRef}
              $slideId={0}
              $slideBackground={articleData?.colors?.secondary}
            >
              <BodySlideImage
                src={images[0].image?.fluid?.src}
                alt={images[0]?.alt || "image"}
                $desktop
              />
              <BodySlideImage
                ref={firstImageMobileRef}
                src={images[0].imageMobile?.fluid?.src}
                alt={images[0]?.alt || "image"}
                $mobile
              />
            </BodySlide>
          )}
        </BodySlider>
      </BodySliderWrapper>

      {bodyItems?.map((component, i) =>
        component.__typename === "DatoCmsParagraph" ? (
          <ParagraphContainer key={i} ref={paragraphRef}>
            <Paragraph
              $primaryColor={articleData?.colors?.primary}
              suppressHydrationWarning
              dangerouslySetInnerHTML={{ __html: component.text }}
            />
          </ParagraphContainer>
        ) : null
      )}
    </>
  );
};

export default BodySliderComponent;
